import React from 'react';

export default function Accordion({ className, item }) {
    const { accordions } = item;

    let renderAccordion = accordions.items.map(({ label, paragraph, id }) => {
        if (label && paragraph)
            return (
                <details key={id}>
                    <summary>{label}</summary>
                    <div
                        className="details-content"
                        dangerouslySetInnerHTML={{ __html: paragraph }}
                    ></div>
                </details>
            );
    });

    return <div className={className}>{renderAccordion}</div>;
}
